


// // // // import React from 'react';
// // // // import toast from 'react-hot-toast';

// // // // const MAX_FILE_SIZE_MB = 5; // Set limit here (change to 10 if needed)
// // // // const MAX_FILE_SIZE = MAX_FILE_SIZE_MB * 1024 * 1024;

// // // // const Step2UploadDocs = ({ data, setData, onNext, onBack }) => {
// // // //   const handleFileChange = (e) => {
// // // //     const { name, files } = e.target;

// // // //     if (!files.length) return;

// // // //     if (name === 'banner') {
// // // //       if (files.length > 5) {
// // // //         toast.error('You can upload up to 5 banner images.');
// // // //         return;
// // // //       }

// // // //       // Check all banner images for size
// // // //       const oversized = Array.from(files).filter(file => file.size > MAX_FILE_SIZE);
// // // //       if (oversized.length > 0) {
// // // //         toast.error(`Each banner image must be less than ${MAX_FILE_SIZE_MB}MB.`);
// // // //         return;
// // // //       }

// // // //       setData({ ...data, [name]: Array.from(files) });
// // // //     } else {
// // // //       const file = files[0];

// // // //       if (file.size > MAX_FILE_SIZE) {
// // // //         toast.error(`${name} must be less than ${MAX_FILE_SIZE_MB}MB.`);
// // // //         return;
// // // //       }

// // // //       setData({ ...data, [name]: file });
// // // //     }
// // // //   };

// // // //   const validate = () => {
// // // //     const requiredFiles = ['logo', 'banner', 'registrationCert', 'affiliationLetter', 'principalID', 'panCard'];

// // // //     for (let file of requiredFiles) {
// // // //       if (!data[file] || (file === 'banner' && (!Array.isArray(data.banner) || data.banner.length === 0))) {
// // // //         toast.error(`Please upload: ${file}`);
// // // //         return false;
// // // //       }
// // // //     }

// // // //     return true;
// // // //   };

// // // //   const handleNext = () => {
// // // //     if (validate()) onNext();
// // // //   };

// // // //   const renderFileLabel = (label, name, required = false, multiple = false) => (
// // // //     <div className="w-full">
// // // //       <label className="block text-sm font-medium text-gray-300 mb-1">
// // // //         {label} {required && <span className="text-red-500">*</span>}
// // // //       </label>
// // // //       <input
// // // //         type="file"
// // // //         name={name}
// // // //         onChange={handleFileChange}
// // // //         multiple={multiple}
// // // //         className="w-full file:mr-4 file:py-2 file:px-4
// // // //                    file:rounded-lg file:border-0
// // // //                    file:text-sm file:font-semibold
// // // //                    file:bg-indigo-600 file:text-white
// // // //                    hover:file:bg-indigo-700
// // // //                    bg-slate-800 text-gray-300 border border-slate-600 rounded-lg cursor-pointer"
// // // //       />
// // // //       {data[name] &&
// // // //         (Array.isArray(data[name]) ? (
// // // //           <ul className="text-xs text-green-400 mt-1 list-disc pl-5 space-y-0.5">
// // // //             {data[name].map((file, idx) => (
// // // //               <li key={idx}>✔ {file.name}</li>
// // // //             ))}
// // // //           </ul>
// // // //         ) : (
// // // //           <p className="text-xs text-green-400 mt-1">✔ {data[name]?.name}</p>
// // // //         ))}
// // // //       <p className="text-xs text-gray-400 mt-1">Max file size: {MAX_FILE_SIZE_MB}MB</p>
// // // //     </div>
// // // //   );

// // // //   return (
// // // //     <div className="space-y-6">
// // // //       {/* Section Title */}
// // // //       <div className="text-center mb-6">
// // // //         <h3 className="text-xl font-semibold text-white">Step 2: Upload Documents</h3>
// // // //         <p className="text-gray-400 text-sm">Please upload all required documents for verification and branding.</p>
// // // //       </div>

// // // //       {/* Upload Fields Grid */}
// // // //       <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
// // // //         {renderFileLabel("School Logo", "logo", true)}
// // // //         {renderFileLabel("School Banner (up to 5 images)", "banner", true, true)}
// // // //         {renderFileLabel("Registration Certificate", "registrationCert", true)}
// // // //         {renderFileLabel("Affiliation Letter", "affiliationLetter", true)}
// // // //         {renderFileLabel("Principal's ID Proof", "principalID", true)}
// // // //         {renderFileLabel("School PAN Card", "panCard", true)}
// // // //       </div>

// // // //       {/* Navigation Buttons */}
// // // //       <div className="flex justify-between pt-6">
// // // //         <button
// // // //           onClick={onBack}
// // // //           className="px-6 py-2 bg-gray-600 hover:bg-gray-700 text-white font-semibold rounded-lg transition duration-200 shadow-md"
// // // //         >
// // // //           ← Back
// // // //         </button>
// // // //         <button
// // // //           onClick={handleNext}
// // // //           className="px-6 py-2 bg-indigo-600 hover:bg-indigo-700 text-white font-semibold rounded-lg transition duration-200 shadow-md"
// // // //         >
// // // //           Next Step →
// // // //         </button>
// // // //       </div>
// // // //     </div>
// // // //   );
// // // // };

// // // // export default Step2UploadDocs;


// // // import React, { useEffect, useState } from 'react';
// // // import toast from 'react-hot-toast';

// // // const MAX_FILE_SIZE_MB = 5;
// // // const MAX_FILE_SIZE = MAX_FILE_SIZE_MB * 1024 * 1024;

// // // const Step2UploadDocs = ({ data, setData, onNext, onBack }) => {
// // //   const [previews, setPreviews] = useState({});

// // //   // Generate image previews
// // //   useEffect(() => {
// // //     const newPreviews = {};
// // //     for (const key in data) {
// // //       const value = data[key];
// // //       if (value) {
// // //         if (Array.isArray(value)) {
// // //           newPreviews[key] = value.map(file => URL.createObjectURL(file));
// // //         } else if (value.type?.startsWith("image/")) {
// // //           newPreviews[key] = URL.createObjectURL(value);
// // //         }
// // //       }
// // //     }

// // //     setPreviews(newPreviews);

// // //     return () => {
// // //       // Cleanup object URLs
// // //       Object.values(newPreviews).flat().forEach(url => URL.revokeObjectURL(url));
// // //     };
// // //   }, [data]);

// // //   const handleFileChange = (e) => {
// // //     const { name, files } = e.target;

// // //     if (!files.length) return;

// // //     if (name === 'banner') {
// // //       if (files.length > 5) {
// // //         toast.error('You can upload up to 5 banner images.');
// // //         return;
// // //       }

// // //       const oversized = Array.from(files).filter(file => file.size > MAX_FILE_SIZE);
// // //       if (oversized.length > 0) {
// // //         toast.error(`Each banner image must be less than ${MAX_FILE_SIZE_MB}MB.`);
// // //         return;
// // //       }

// // //       setData({ ...data, [name]: Array.from(files) });
// // //     } else {
// // //       const file = files[0];

// // //       if (file.size > MAX_FILE_SIZE) {
// // //         toast.error(`${name} must be less than ${MAX_FILE_SIZE_MB}MB.`);
// // //         return;
// // //       }

// // //       setData({ ...data, [name]: file });
// // //     }
// // //   };

// // //   const validate = () => {
// // //     const requiredFiles = ['logo', 'banner', 'registrationCert', 'affiliationLetter', 'principalID', 'panCard'];

// // //     for (let file of requiredFiles) {
// // //       if (!data[file] || (file === 'banner' && (!Array.isArray(data.banner) || data.banner.length === 0))) {
// // //         toast.error(`Please upload: ${file}`);
// // //         return false;
// // //       }
// // //     }

// // //     return true;
// // //   };

// // //   const handleNext = () => {
// // //     if (validate()) onNext();
// // //   };

// // //   const renderImagePreview = (name) => {
// // //     if (!previews[name]) return null;

// // //     if (Array.isArray(previews[name])) {
// // //       return (
// // //         <div className="flex flex-wrap gap-2 mt-2">
// // //           {previews[name].map((url, idx) => (
// // //             <img
// // //               key={idx}
// // //               src={url}
// // //               alt={`Preview ${idx}`}
// // //               className="h-16 w-28 object-cover rounded border border-gray-600"
// // //             />
// // //           ))}
// // //         </div>
// // //       );
// // //     } else {
// // //       return (
// // //         <img
// // //           src={previews[name]}
// // //           alt="Preview"
// // //           className="h-16 w-28 object-cover rounded mt-2 border border-gray-600"
// // //         />
// // //       );
// // //     }
// // //   };

// // //   const renderFileLabel = (label, name, required = false, multiple = false) => (
// // //     <div className="w-full">
// // //       <label className="block text-sm font-medium text-gray-300 mb-1">
// // //         {label} {required && <span className="text-red-500">*</span>}
// // //       </label>
// // //       <input
// // //         type="file"
// // //         name={name}
// // //         onChange={handleFileChange}
// // //         multiple={multiple}
// // //         accept="image/*"
// // //         className="w-full file:mr-4 file:py-2 file:px-4
// // //                    file:rounded-lg file:border-0
// // //                    file:text-sm file:font-semibold
// // //                    file:bg-indigo-600 file:text-white
// // //                    hover:file:bg-indigo-700
// // //                    bg-slate-800 text-gray-300 border border-slate-600 rounded-lg cursor-pointer"
// // //       />
// // //       {data[name] &&
// // //         (Array.isArray(data[name]) ? (
// // //           <ul className="text-xs text-green-400 mt-1 list-disc pl-5 space-y-0.5">
// // //             {data[name].map((file, idx) => (
// // //               <li key={idx}>✔ {file.name}</li>
// // //             ))}
// // //           </ul>
// // //         ) : (
// // //           <p className="text-xs text-green-400 mt-1">✔ {data[name]?.name}</p>
// // //         ))}
// // //       <p className="text-xs text-gray-400 mt-1">Max file size: {MAX_FILE_SIZE_MB}MB</p>
// // //       {renderImagePreview(name)}
// // //     </div>
// // //   );

// // //   return (
// // //     <div className="space-y-6">
// // //       {/* Section Title */}
// // //       <div className="text-center mb-6">
// // //         <h3 className="text-xl font-semibold text-white">Step 2: Upload Documents</h3>
// // //         <p className="text-gray-400 text-sm">Please upload all required documents for verification and branding.</p>
// // //       </div>

// // //       {/* Upload Fields Grid */}
// // //       <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
// // //         {renderFileLabel("School Logo", "logo", true)}
// // //         {renderFileLabel("School Banner (up to 5 images)", "banner", true, true)}
// // //         {renderFileLabel("Registration Certificate", "registrationCert", true)}
// // //         {renderFileLabel("Affiliation Letter", "affiliationLetter", true)}
// // //         {renderFileLabel("Principal's ID Proof", "principalID", true)}
// // //         {renderFileLabel("School PAN Card", "panCard", true)}
// // //       </div>

// // //       {/* Navigation Buttons */}
// // //       <div className="flex justify-between pt-6">
// // //         <button
// // //           onClick={onBack}
// // //           className="px-6 py-2 bg-gray-600 hover:bg-gray-700 text-white font-semibold rounded-lg transition duration-200 shadow-md"
// // //         >
// // //           ← Back
// // //         </button>
// // //         <button
// // //           onClick={handleNext}
// // //           className="px-6 py-2 bg-indigo-600 hover:bg-indigo-700 text-white font-semibold rounded-lg transition duration-200 shadow-md"
// // //         >
// // //           Next Step →
// // //         </button>
// // //       </div>
// // //     </div>
// // //   );
// // // };

// // // export default Step2UploadDocs;


// // import React, { useEffect, useState } from 'react';
// // import toast from 'react-hot-toast';
// // import { CheckCircleIcon } from '@heroicons/react/24/solid';

// // const MAX_FILE_SIZE_MB = 5;
// // const MAX_FILE_SIZE = MAX_FILE_SIZE_MB * 1024 * 1024;

// // const Step2UploadDocs = ({ data, setData, onNext, onBack }) => {
// //   const [previews, setPreviews] = useState({});

// //   useEffect(() => {
// //     const newPreviews = {};
// //     for (const key in data) {
// //       const value = data[key];
// //       if (value) {
// //         if (Array.isArray(value)) {
// //           newPreviews[key] = value.map(file => URL.createObjectURL(file));
// //         } else if (value.type?.startsWith("image/")) {
// //           newPreviews[key] = URL.createObjectURL(value);
// //         }
// //       }
// //     }

// //     setPreviews(newPreviews);

// //     return () => {
// //       Object.values(newPreviews).flat().forEach(url => URL.revokeObjectURL(url));
// //     };
// //   }, [data]);

// //   const handleFileChange = (e) => {
// //     const { name, files } = e.target;

// //     if (!files.length) return;

// //     if (name === 'banner') {
// //       if (files.length > 5) {
// //         toast.error('You can upload up to 5 banner images.');
// //         return;
// //       }

// //       const oversized = Array.from(files).filter(file => file.size > MAX_FILE_SIZE);
// //       if (oversized.length > 0) {
// //         toast.error(`Each banner image must be less than ${MAX_FILE_SIZE_MB}MB.`);
// //         return;
// //       }

// //       setData({ ...data, [name]: Array.from(files) });
// //     } else {
// //       const file = files[0];

// //       if (file.size > MAX_FILE_SIZE) {
// //         toast.error(`${name} must be less than ${MAX_FILE_SIZE_MB}MB.`);
// //         return;
// //       }

// //       setData({ ...data, [name]: file });
// //     }
// //   };

// //   const validate = () => {
// //     const requiredFiles = ['logo', 'banner', 'registrationCert', 'affiliationLetter', 'principalID', 'panCard'];

// //     for (let file of requiredFiles) {
// //       if (!data[file] || (file === 'banner' && (!Array.isArray(data.banner) || data.banner.length === 0))) {
// //         toast.error(`Please upload: ${file}`);
// //         return false;
// //       }
// //     }

// //     return true;
// //   };

// //   const handleNext = () => {
// //     if (validate()) onNext();
// //   };

// //   const renderImagePreview = (name) => {
// //     if (!previews[name]) return null;

// //     if (Array.isArray(previews[name])) {
// //       return (
// //         <div className="flex flex-wrap gap-2 mt-2">
// //           {previews[name].map((url, idx) => (
// //             <img
// //               key={idx}
// //               src={url}
// //               alt={`Preview ${idx}`}
// //               className="h-16 w-28 object-cover rounded-md border border-[#E3E8F0]"
// //             />
// //           ))}
// //         </div>
// //       );
// //     } else {
// //       return (
// //         <img
// //           src={previews[name]}
// //           alt="Preview"
// //           className="h-16 w-28 object-cover rounded-md mt-2 border border-[#E3E8F0]"
// //         />
// //       );
// //     }
// //   };

// //   const renderFileLabel = (label, name, required = false, multiple = false) => (
// //     <div className="w-full bg-[#F4F8FC] border border-[#E3E8F0] rounded-xl p-4">
// //       <label className="block text-sm font-medium text-[#101826] font-['Sora',sans-serif] mb-2">
// //         {label} {required && <span className="text-red-500">*</span>}
// //       </label>
// //       <input
// //         type="file"
// //         name={name}
// //         onChange={handleFileChange}
// //         multiple={multiple}
// //         accept="image/*"
// //         className="w-full text-sm text-[#5A6478] font-['Sora',sans-serif]
// //                    file:mr-4 file:py-2 file:px-4
// //                    file:rounded-lg file:border-0
// //                    file:text-sm file:font-semibold
// //                    file:bg-[#163863] file:text-white
// //                    hover:file:bg-[#2E63B8]
// //                    cursor-pointer"
// //       />
// //       {data[name] &&
// //         (Array.isArray(data[name]) ? (
// //           <ul className="text-xs text-emerald-600 font-['Sora',sans-serif] mt-2 space-y-1">
// //             {data[name].map((file, idx) => (
// //               <li key={idx} className="flex items-center gap-1">
// //                 <CheckCircleIcon className="w-3.5 h-3.5" /> {file.name}
// //               </li>
// //             ))}
// //           </ul>
// //         ) : (
// //           <p className="text-xs text-emerald-600 font-['Sora',sans-serif] mt-2 flex items-center gap-1">
// //             <CheckCircleIcon className="w-3.5 h-3.5" /> {data[name]?.name}
// //           </p>
// //         ))}
// //       <p className="text-xs text-[#8891A0] font-['Sora',sans-serif] mt-1.5">Max file size: {MAX_FILE_SIZE_MB}MB</p>
// //       {renderImagePreview(name)}
// //     </div>
// //   );

// //   return (
// //     <div className="space-y-6">
// //       <div className="text-center mb-6">
// //         <h3 className="font-['Sora',sans-serif] text-xl font-semibold text-[#101826]">Step 2: Upload Documents</h3>
// //         <p className="text-[#5A6478] font-['Sora',sans-serif] text-sm">Please upload all required documents for verification and branding.</p>
// //       </div>

// //       <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
// //         {renderFileLabel("School Logo", "logo", true)}
// //         {renderFileLabel("School Banner (up to 5 images)", "banner", true, true)}
// //         {renderFileLabel("Registration Certificate", "registrationCert", true)}
// //         {renderFileLabel("Affiliation Letter", "affiliationLetter", true)}
// //         {renderFileLabel("Principal's ID Proof", "principalID", true)}
// //         {renderFileLabel("School PAN Card", "panCard", true)}
// //       </div>

// //       <div className="flex justify-between pt-6">
// //         <button
// //           onClick={onBack}
// //           className="px-6 py-2.5 bg-white border border-[#D8DEE9] hover:border-[#2E63B8] hover:text-[#2E63B8] text-[#5A6478] font-['Sora',sans-serif] font-semibold rounded-lg transition-colors duration-200"
// //         >
// //           ← Back
// //         </button>
// //         <button
// //           onClick={handleNext}
// //           className="px-6 py-2.5 bg-[#163863] hover:bg-[#2E63B8] text-white font-['Sora',sans-serif] font-semibold rounded-lg transition-colors duration-200 shadow-sm"
// //         >
// //           Next step →
// //         </button>
// //       </div>
// //     </div>
// //   );
// // };

// // export default Step2UploadDocs;


// import React, { useEffect, useState } from 'react';
// import toast from 'react-hot-toast';
// import { CheckCircleIcon, DocumentArrowUpIcon } from '@heroicons/react/24/solid';

// const displayFont = { fontFamily: "'Fraunces', serif" };
// const MAX_FILE_SIZE_MB = 5;
// const MAX_FILE_SIZE = MAX_FILE_SIZE_MB * 1024 * 1024;

// const Step2UploadDocs = ({ data, setData, onNext, onBack }) => {
//   const [previews, setPreviews] = useState({});

//   useEffect(() => {
//     const newPreviews = {};
//     for (const key in data) {
//       const value = data[key];
//       if (value) {
//         if (Array.isArray(value)) {
//           newPreviews[key] = value.map(file => URL.createObjectURL(file));
//         } else if (value.type?.startsWith("image/")) {
//           newPreviews[key] = URL.createObjectURL(value);
//         }
//       }
//     }

//     setPreviews(newPreviews);

//     return () => {
//       Object.values(newPreviews).flat().forEach(url => URL.revokeObjectURL(url));
//     };
//   }, [data]);

//   const handleFileChange = (e) => {
//     const { name, files } = e.target;

//     if (!files.length) return;

//     if (name === 'banner') {
//       if (files.length > 5) {
//         toast.error('You can upload up to 5 banner images.');
//         return;
//       }

//       const oversized = Array.from(files).filter(file => file.size > MAX_FILE_SIZE);
//       if (oversized.length > 0) {
//         toast.error(`Each banner image must be less than ${MAX_FILE_SIZE_MB}MB.`);
//         return;
//       }

//       setData({ ...data, [name]: Array.from(files) });
//     } else {
//       const file = files[0];

//       if (file.size > MAX_FILE_SIZE) {
//         toast.error(`${name} must be less than ${MAX_FILE_SIZE_MB}MB.`);
//         return;
//       }

//       setData({ ...data, [name]: file });
//     }
//   };

//   const validate = () => {
//     const requiredFiles = ['logo', 'banner', 'registrationCert', 'affiliationLetter', 'principalID', 'panCard'];

//     for (let file of requiredFiles) {
//       if (!data[file] || (file === 'banner' && (!Array.isArray(data.banner) || data.banner.length === 0))) {
//         toast.error(`Please upload: ${file}`);
//         return false;
//       }
//     }

//     return true;
//   };

//   const handleNext = () => {
//     if (validate()) onNext();
//   };

//   const renderImagePreview = (name) => {
//     if (!previews[name]) return null;

//     if (Array.isArray(previews[name])) {
//       return (
//         <div className="flex flex-wrap gap-2 mt-3">
//           {previews[name].map((url, idx) => (
//             <img
//               key={idx}
//               src={url}
//               alt={`Preview ${idx}`}
//               className="h-16 w-28 object-cover rounded-lg border border-[#E3E8F0]"
//             />
//           ))}
//         </div>
//       );
//     } else {
//       return (
//         <img
//           src={previews[name]}
//           alt="Preview"
//           className="h-16 w-28 object-cover rounded-lg mt-3 border border-[#E3E8F0]"
//         />
//       );
//     }
//   };

//   const renderFileLabel = (label, name, required = false, multiple = false) => (
//     <div className="w-full bg-white border border-[#E3E8F0] rounded-2xl p-5 shadow-[0_1px_2px_rgba(16,24,38,0.04)] transition-shadow duration-150 hover:shadow-[0_10px_24px_-16px_rgba(16,24,38,0.2)]">
//       <div className="flex items-center gap-2 mb-3">
//         <div className="w-8 h-8 rounded-lg bg-[#EAF1FB] flex items-center justify-center shrink-0">
//           <DocumentArrowUpIcon className="w-4 h-4 text-[#2E63B8]" />
//         </div>
//         <label className="text-sm font-medium text-[#101826]">
//           {label} {required && <span className="text-red-500">*</span>}
//         </label>
//       </div>
//       <input
//         type="file"
//         name={name}
//         onChange={handleFileChange}
//         multiple={multiple}
//         accept="image/*"
//         className="w-full text-sm text-[#5A6478]
//                    file:mr-4 file:py-2 file:px-4
//                    file:rounded-lg file:border-0
//                    file:text-sm file:font-semibold
//                    file:bg-[#163863] file:text-white
//                    hover:file:bg-[#2E63B8]
//                    cursor-pointer"
//       />
//       {data[name] &&
//         (Array.isArray(data[name]) ? (
//           <ul className="text-xs text-emerald-600 mt-2 space-y-1">
//             {data[name].map((file, idx) => (
//               <li key={idx} className="flex items-center gap-1">
//                 <CheckCircleIcon className="w-3.5 h-3.5" /> {file.name}
//               </li>
//             ))}
//           </ul>
//         ) : (
//           <p className="text-xs text-emerald-600 mt-2 flex items-center gap-1">
//             <CheckCircleIcon className="w-3.5 h-3.5" /> {data[name]?.name}
//           </p>
//         ))}
//       <p className="text-xs text-[#A6AFBD] mt-1.5">Max file size: {MAX_FILE_SIZE_MB}MB</p>
//       {renderImagePreview(name)}
//     </div>
//   );

//   return (
//     <div className="space-y-8">
//       <div className="text-center -mt-2 mb-2">
//         <h3 style={displayFont} className="text-xl text-[#101826]">Step 2: Upload Documents</h3>
//         <p className="text-[#5A6478] text-sm mt-1">Please upload all required documents for verification and branding.</p>
//       </div>

//       <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
//         {renderFileLabel("School Logo", "logo", true)}
//         {renderFileLabel("School Banner (up to 5 images)", "banner", true, true)}
//         {renderFileLabel("Registration Certificate", "registrationCert", true)}
//         {renderFileLabel("Affiliation Letter", "affiliationLetter", true)}
//         {renderFileLabel("Principal's ID Proof", "principalID", true)}
//         {renderFileLabel("School PAN Card", "panCard", true)}
//       </div>

//       <div className="flex justify-between pt-2">
//         <button
//           onClick={onBack}
//           className="px-7 py-3 rounded-full border border-[#D8DEE9] text-[#5A6478] font-semibold hover:border-[#2E63B8] hover:text-[#2E63B8] transition-colors duration-200"
//         >
//           ← Back
//         </button>
//         <button
//           onClick={handleNext}
//           className="inline-flex items-center gap-2 px-7 py-3 rounded-full bg-gradient-to-r from-[#163863] to-[#2E63B8] text-white font-semibold shadow-lg shadow-[#163863]/25 hover:shadow-xl hover:-translate-y-0.5 transition-all duration-200"
//         >
//           Next step →
//         </button>
//       </div>
//     </div>
//   );
// };

// export default Step2UploadDocs;

import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { CheckCircleIcon, DocumentArrowUpIcon } from '@heroicons/react/24/solid';

const displayFont = { fontFamily: "'Fraunces', serif" };
const MAX_FILE_SIZE_MB = 5;
const MAX_FILE_SIZE = MAX_FILE_SIZE_MB * 1024 * 1024;

const Step2UploadDocs = ({ data, setData, onNext, onBack }) => {
  const [previews, setPreviews] = useState({});

  useEffect(() => {
    const newPreviews = {};
    for (const key in data) {
      const value = data[key];
      if (value) {
        if (Array.isArray(value)) {
          newPreviews[key] = value.map(file => URL.createObjectURL(file));
        } else if (value.type?.startsWith("image/")) {
          newPreviews[key] = URL.createObjectURL(value);
        }
      }
    }

    setPreviews(newPreviews);

    return () => {
      Object.values(newPreviews).flat().forEach(url => URL.revokeObjectURL(url));
    };
  }, [data]);

  const handleFileChange = (e) => {
    const { name, files } = e.target;

    if (!files.length) return;

    if (name === 'banner') {
      if (files.length > 5) {
        toast.error('You can upload up to 5 banner images.');
        return;
      }

      const oversized = Array.from(files).filter(file => file.size > MAX_FILE_SIZE);
      if (oversized.length > 0) {
        toast.error(`Each banner image must be less than ${MAX_FILE_SIZE_MB}MB.`);
        return;
      }

      setData({ ...data, [name]: Array.from(files) });
    } else {
      const file = files[0];

      if (file.size > MAX_FILE_SIZE) {
        toast.error(`${name} must be less than ${MAX_FILE_SIZE_MB}MB.`);
        return;
      }

      setData({ ...data, [name]: file });
    }
  };

  const validate = () => {
    const requiredFiles = ['logo', 'banner', 'registrationCert', 'affiliationLetter', 'principalID', 'panCard'];

    for (let file of requiredFiles) {
      if (!data[file] || (file === 'banner' && (!Array.isArray(data.banner) || data.banner.length === 0))) {
        toast.error(`Please upload: ${file}`);
        return false;
      }
    }

    return true;
  };

  const handleNext = () => {
    if (validate()) onNext();
  };

  const renderImagePreview = (name) => {
    if (!previews[name]) return null;

    if (Array.isArray(previews[name])) {
      return (
        <div className="flex flex-wrap gap-2 mt-3">
          {previews[name].map((url, idx) => (
            <img
              key={idx}
              src={url}
              alt={`Preview ${idx}`}
              className="h-16 w-28 object-cover rounded-lg border border-[#E3E8F0]"
            />
          ))}
        </div>
      );
    } else {
      return (
        <img
          src={previews[name]}
          alt="Preview"
          className="h-16 w-28 object-cover rounded-lg mt-3 border border-[#E3E8F0]"
        />
      );
    }
  };

  const renderFileLabel = (label, name, required = false, multiple = false) => (
    <div className="w-full bg-white border border-[#E3E8F0] rounded-2xl p-5 shadow-[0_1px_2px_rgba(16,24,38,0.04)] transition-shadow duration-150 hover:shadow-[0_10px_24px_-16px_rgba(16,24,38,0.2)]">
      <div className="flex items-center gap-2 mb-3">
        <div className="w-8 h-8 rounded-lg bg-[#EAF1FB] flex items-center justify-center shrink-0">
          <DocumentArrowUpIcon className="w-4 h-4 text-[#2E63B8]" />
        </div>
        <label className="text-sm font-medium text-[#101826]">
          {label} {required && <span className="text-red-500">*</span>}
        </label>
      </div>
      <input
        type="file"
        name={name}
        onChange={handleFileChange}
        multiple={multiple}
        accept="image/*"
        className="w-full text-sm text-[#5A6478]
                   file:mr-4 file:py-2 file:px-4
                   file:rounded-lg file:border-0
                   file:text-sm file:font-semibold
                   file:bg-[#163863] file:text-white
                   hover:file:bg-[#2E63B8]
                   cursor-pointer"
      />
      {data[name] &&
        (Array.isArray(data[name]) ? (
          <ul className="text-xs text-emerald-600 mt-2 space-y-1">
            {data[name].map((file, idx) => (
              <li key={idx} className="flex items-center gap-1">
                <CheckCircleIcon className="w-3.5 h-3.5" /> {file.name}
              </li>
            ))}
          </ul>
        ) : (
          <p className="text-xs text-emerald-600 mt-2 flex items-center gap-1">
            <CheckCircleIcon className="w-3.5 h-3.5" /> {data[name]?.name}
          </p>
        ))}
      <p className="text-xs text-[#A6AFBD] mt-1.5">Max file size: {MAX_FILE_SIZE_MB}MB</p>
      {renderImagePreview(name)}
    </div>
  );

  return (
    <div className="space-y-8">
      <div className="text-center -mt-2 mb-2">
        <h3 style={displayFont} className="text-xl text-[#101826]">Step 2: Upload Documents</h3>
        <p className="text-[#5A6478] text-sm mt-1">Please upload all required documents for verification and branding.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        {renderFileLabel("School Logo", "logo", true)}
        {renderFileLabel("School Banner (up to 5 images)", "banner", true, true)}
        {renderFileLabel("Registration Certificate", "registrationCert", true)}
        {renderFileLabel("Affiliation Letter", "affiliationLetter", true)}
        {renderFileLabel("Principal's ID Proof", "principalID", true)}
        {renderFileLabel("School PAN Card", "panCard", true)}
      </div>

      <div className="flex justify-between pt-2">
        <button
          onClick={onBack}
          className="px-6 py-2.5 rounded-full border border-[#D8DEE9] text-[#5A6478] font-semibold hover:border-[#2E63B8] hover:text-[#2E63B8] transition-colors duration-200"
        >
          ← Back
        </button>
        <button
          onClick={handleNext}
          className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full bg-gradient-to-r from-[#163863] to-[#2E63B8] text-white font-semibold shadow-lg shadow-[#163863]/25 hover:shadow-xl hover:-translate-y-0.5 transition-all duration-200"
        >
          Next step →
        </button>
      </div>
    </div>
  );
};

export default Step2UploadDocs;

